module.exports = __webpack_public_path__ + "static/DSC_4404-2-b792dcc11f5054b719fccb27a4bddda2.jpg";